<template>
  <div
    style="display: flex; align-items: center; justify-content: center"
    v-if="item.agentConditions.sale"
  >
    <v-icon
      right
      small
      style="margin: 0"
      @click="() => getFilterNotes(item, item.agentConditions.sale)"
      >info</v-icon
    >
  </div>
</template>
<script>
export default {
  name: "agent-conditions-tooltip",
  data: () => ({}),
  props: {
    item: { type: Object },
  },
  methods: {
    async getFilterNotes(item, sale) {
      const { data } = await this.$store.dispatch("getRate", item.product_id);
      // console.log('sale',sale, sale.agentsfee_note);
      const text = [];
      const title = [];
      sale.standart == 1
        ? title.push("<p>Стандартные условия работы банка</p>")
        : title.push(
            `<p>Акционные условия банка &nbsp; c ${sale.saleDate[0]} по ${sale.saleDate[1]}</p>`
          );

        text.push(`<p>
          <span style="text-decoration: underline;">Условия работы с агентами. </span> <br /><br />
          <span style="text-decoration: underline;">${
            sale.what_fee === "range"
              ? "АВ входит в комиссию"
              : "АВ с превышения нетто"
          }</span>
          ${sale.agentsfee_note ? `<p>${sale.agentsfee_note}</p>` : ''}
        </p>`);

      sale.agentsup_note &&
        text.push(`<p>
          <span style="text-decoration: underline;">Выплаты при превышении стандартного тарифа</span>
          <p>${sale.agentsup_note}</p>
        </p>`);

      sale.down_description &&
        text.push(`<p>
          <span style="text-decoration: underline;">Условия выплат агентам при снижении</span>
          <p>${sale.down_description}</p>
          </p>`);

      //Виды принципалов
      const principals = this.$store.getters.getProductData.principals;
      const principalsFind = principals.find((item) => item.selected);
      if (principalsFind) {
        // const principal = item.principal.split(",");
        // const principalText = [];
        // for (const row of principals) {
        //   for (const p of principal) {
        //     if (row.id == parseInt(p)) {
        //       principalText.push(row.name);
        //     }
        //   }
        // }
        data.rate.principal_note && data.rate.principal_note!==null && text.push(`<p>
            <span style="text-decoration: underline;">Виды принципалов</span>
            <p>${data.rate.principal_note}</p>
          </p>`);
      }

      //Установление лимита на Принципала
      const arrs = this.$store.getters.getProductData.limits;
      const limitsFind = arrs.find((item) => item.selected);
      if (limitsFind) {
        // const newText = [];
        // for (const row of arrs) {
        //   if (row.id == item.limit) {
        //     newText.push(row.name);
        //   }
        // }
        data.rate.limit_note &&
          data.rate.limit_note !== null &&
          text.push(`<p>
            <span style="text-decoration: underline;">Установление лимита на Принципала</span>
            <p>${data.rate.limit_note}</p>
          </p>`);
      }

      //Гарантия по форме заказчика
      this.$store.getters.get_garantZakaz &&
        text.push(`<p>
            <span style="text-decoration: underline;">Гарантия по форме заказчика</span>
            <p>${item.garantZakaz ? "Да" : "Нет"}</p>
            <p>${
              data.rate.gar_polz_zak_note &&
              data.rate.gar_polz_zak_note !== null
                ? data.rate.gar_polz_zak_note
                : ""
            }</p>
          </p>`);

      //Срок существования клиента, мес.
      const lifes = this.$store.getters.getProductData.lifes;
      const lifesFind = lifes.find((item) => item.selected);
      if (lifesFind) {
        // const arr = item.lifes.split(",");
        // const arrText = [];
        // for (const row of lifes) {
        //   for (const p of arr) {
        //     if (row.id == parseInt(p)) {
        //       arrText.push(row.name);
        //     }
        //   }
        // }
        data.rate.life_note &&
          data.rate.life_note !== null &&
          text.push(`<p>
            <span style="text-decoration: underline;">Срок существования клиента, мес.</span>
            <p>${data.rate.life_note}</p>
          </p>`);
      }

      //Опыт исполнения контрактов и/или договоров, шт.
      const practices = this.$store.getters.getProductData.practices;
      const practicesFind = practices.find((item) => item.selected);
      if (practicesFind) {
        // const arr = item.practices.split(",");
        // const arrText = [];
        // for (const row of practices) {
        //   for (const p of arr) {
        //     if (row.id == parseInt(p)) {
        //       arrText.push(row.name);
        //     }
        //   }
        // }
        data.rate.practice_note &&
          data.rate.practice_note !== null &&
          text.push(`<p>
            <span style="text-decoration: underline;">Опыт исполнения контрактов и/или договоров, шт.</span>
            <p>${data.rate.practice_note}</p>
          </p>`);
      }

      //Пакет документов для получения гарантии
      const packets = this.$store.getters.getProductData.packets;
      const packetsFind = packets.find((item) => item.selected);
      if (packetsFind) {
        // const arr = item.packets.split(",");
        // const arrText = [];
        // for (const row of packets) {
        //   for (const p of arr) {
        //     if (row.id == parseInt(p)) {
        //       arrText.push(row.name);
        //     }
        //   }
        // }
        data.rate.packet_note &&
          data.rate.packet_note !== null &&
          text.push(`<p>
            <span style="text-decoration: underline;">Пакет документов для получения гарантии</span>
            <p>${data.rate.packet_note}</p>
          </p>`);
      }

      //Промежуточная управленческая отчетность ф.1 и ф.2 при УСН
      const usns = this.$store.getters.getProductData.usns;
      const usnsFind = usns.find((item) => item.selected);
      if (usnsFind) {
        const arrText = [];
        for (const row of usns) {
          if (row.id == item.usn) {
            arrText.push(row.name);
          }
        }
        text.push(`<p>
            <span style="text-decoration: underline;">Промежуточная управленческая отчетность ф.1 и ф.2 при УСН</span>
            <p>${
              data.rate.usn_note && data.rate.usn_note !== null
                ? data.rate.usn_note
                : arrText.join(", ")
            }</p>
          </p>`);
      }

      //ЭДО с агентом
      const edos = this.$store.getters.getProductData.edos;
      const edosFind = edos.find((item) => item.selected);
      if (edosFind) {
        const arr = item.edos.split(",");
        const arrText = [];
        for (const row of edos) {
          for (const p of arr) {
            if (row.id == parseInt(p)) {
              arrText.push(row.name);
            }
          }
        }

        text.push(`<p>
            <span style="text-decoration: underline;">ЭДО с агентом</span>
            <p>${data.rate.edo_note && data.rate.edo_note !== null ? data.rate.edo_note : arrText.join(", ")}</p>
          </p>`);
      }

      // text.push(`<p>
      //     <span style="text-decoration: underline;">Минимальный тариф</span>
      //     <p>${sale.min_tarif_note}</p>
      //   </p>`);

      sale.up_description &&
        text.push(`<p>
          <span style="text-decoration: underline;">Возможность согласовать повышенное АВ</span>
          <p>${sale.up_description}</p>
        </p>`);

      if (
        this.$store.getters.get_edo_sdelka ||
        this.$store.getters.get_edo_mounth ||
        this.$store.getters.get_edo_decada ||
        this.$store.getters.get_edo_week ||
        this.$store.getters.get_edo_personal
      ) {
        const arr = [];
        sale.edo_sdelka === 1 && arr.push("по сделке");
        sale.edo_mounth === 1 && arr.push("ежемесячно");
        sale.edo_decada === 1 && arr.push("по декадам");
        sale.edo_week === 1 && arr.push("еженедельно");
        sale.edo_personal === 1 && arr.push("индивидуально");

        text.push(`<p>
          <span style="text-decoration: underline;">Выплаты АВ</span>
          <p>${sale.edo && sale.edo!==null ? sale.edo : arr.join(", ")}</p>
        </p>`);
      }

      this.$emit("dialog", {
        dialog: true,
        dialogText: text.join(""),
        dialogTitle: title.join(""),
      });
    },
  },
};
</script>
<style lang="sass" scoped></style>
